import { useQuery } from '@tanstack/react-query';

import api from '@/services/api';
import { BrazilianState } from '@/types/discovery';

/** Catálogo IBGE servido pela API (estático, sem chamada externa em runtime). */
export const locationKeys = {
  all: ['locations'] as const,
  states: () => [...locationKeys.all, 'states'] as const,
  cities: (uf: string) => [...locationKeys.all, 'cities', uf] as const,
};

const CATALOG_STALE_TIME = 24 * 60 * 60 * 1000;

export function useStates() {
  return useQuery({
    queryKey: locationKeys.states(),
    queryFn: async () => {
      const res = await api.get<BrazilianState[]>('/public/locations/states');
      return res.data;
    },
    staleTime: CATALOG_STALE_TIME,
  });
}

export function useCities(uf: string | null | undefined) {
  return useQuery({
    queryKey: locationKeys.cities(uf ?? ''),
    queryFn: async () => {
      const res = await api.get<{ uf: string; cities: string[] }>('/public/locations/cities', {
        params: { uf },
      });
      return res.data.cities;
    },
    enabled: Boolean(uf),
    staleTime: CATALOG_STALE_TIME,
  });
}
